export const SET_PAGE_TITLE = 'SET_PAGE_TITLE'
export const SET_PAGE_DESC = 'SET_PAGE_DESC'
export const SET_PAGE_LANG = 'SET_PAGE_LANG'
export const SET_SPLASH_MODE = 'SET_SPLASH_MODE'
export const SHOW_MENU = 'SHOW_MENU'
export const HIDE_MENU = 'HIDE_MENU'
export const CHANGE_THEME = 'CHANGE_THEME'
export const CHANGE_STORE = 'CHANGE_STORE'
export const CHANGE_COUNTRY = 'CHANGE_COUNTRY'
export const CHANGE_STEP = 'CHANGE_STEP'
export const SELECT_PRODUCT = 'SELECT_PRODUCT'
export const SELECT_ORDER_COUNT = 'SELECT_ORDER_COUNT'
export const SELECT_RETAIL_COUNT = 'SELECT_RETAIL_COUNT'
export const SHOW_LOADING = 'SHOW_LOADING'
export const HIDE_LOADING = 'HIDE_LOADING'
export const SHOW_DROP_MENU = 'SHOW_DROP_MENU'
export const HIDE_DROP_MENU = 'HIDE_DROP_MENU'
export const CHANGE_DROP_MENU = 'CHANGE_DROP_MENU'
export const CHANGE_FAULT_INFO = 'CHANGE_FAULT_INFO'
export const CHANGE_FAULT_MSG = 'CHANGE_FAULT_MSG'

export const COUNTRY = { 
  'TAIWAN' : 886
}
  